import * as React from 'react';
import {Link} from "react-router-dom";
import {Main} from "../components/Main";
import {Box} from "../components/sharedComponents/Box";
import {FormField, RequiredLegend} from "../components/sharedComponents/Forms";
import Services from "../utilities/Services";
import {notify} from "../utilities/notify";

export class LostPassword extends React.Component<any, any> {

    naglowekSukcesu = React.createRef<HTMLHeadingElement>();

    state = {
        resetSuccess: false,
        email: ''
    }

    componentDidUpdate(_prevProps: any, prevState: any) {
        if (!prevState.resetSuccess && this.state.resetSuccess && this.naglowekSukcesu.current) {
            this.naglowekSukcesu.current.focus();
        }
    }

    onChangeEmail = (e: any) => {
        this.setState({email: e.target.value});
    }

    onReset = (e: React.FormEvent<any>) => {
        e.preventDefault()

        Services.ResetHasla(this.state.email)
            .then((response) => {
                if (response.status === 200) {
                    console.log("Reset ok");
                    this.setState({resetSuccess: true});
                }
            }).catch((error) => {
            notify.error(error.response.data.message, 'Błąd resetowania hasła');
            console.log('Reset error');
        })
    }

    render() {
        let {resetSuccess} = this.state;

        return <Main active={'LOGIN'} title={'Zapomniałem hasła'}>
            <Box>
                {(!resetSuccess) ?
                    <>
                        <h1 className={'h3'}>Zapomniałem hasła</h1>
                        <p>Podaj adres e-mail by zresetować dostęp do konta.</p>
                        <form onSubmit={this.onReset}>
                            <section className={'register-form'}>
                                <RequiredLegend/>
                                <div className={'row'}>
                                    <FormField label={'E-mail:'} required>
                                        <input type={'email'} className={'form-control'} autoComplete={'email'}
                                               onChange={this.onChangeEmail} name={'email'}/>
                                    </FormField>
                                    <div className={'col-sm-2'}/>
                                    <div className={'col-sm-10'}>
                                        <Link to={'/login'}><span className={'password-lost'}>Przejdź do logowania</span></Link>
                                    </div>
                                </div>
                            </section>
                            <div className={'buttons-line'}>
                                <button type={'submit'} className={'btn btn-custom-secondary'}>Resetuj hasło</button>
                            </div>
                        </form>
                    </>
                    :
                    <>
                        <h1 className={'h3'} style={{color: 'green'}} ref={this.naglowekSukcesu} tabIndex={-1}>Hasło zostało zresetowane</h1>
                        <p>Na podany adres e-mail została wysłana wiadomość z linkiem do ustawienia nowego hasła.</p>
                    </>
                }
            </Box>
        </Main>
    }
}

export default LostPassword
